import e,{css as r}from"../../node_modules/styled-components/dist/styled-components.esm.js";import{defaultTheme as t}from"../../theme/index.js";const o=e.button`
  position: relative;
  display: block;
  font-size: 0;
  border: none;
  border-radius: 50%;
  background-color: transparent;

  &:hover {
    cursor: pointer;
    background-color: #d9e5f0;
  }

  &::after,
  &::before {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60%;
    height: 1px;
    content: '';
    border-radius: 2px;
    background-color: ${e=>e.color};
  }

  &::before {
    transform: translate(-50%, -50%) rotate(-45deg);
  }

  &::after {
    transform: translate(-50%, -50%) rotate(45deg);
  }

  &:active {
    cursor: pointer;
  }

  ${({size:e})=>{switch(e){case"small":return r`
          width: 12px;
          height: 12px;

          &::after,
          &::before {
            width: 6px;
            height: 1px;
          }
        `;case"large":return r`
          width: 20px;
          height: 20px;

          &::after,
          &::before {
            width: 16px;
            height: 2px;
          }
        `;default:return r`
          width: 16px;
          height: 16px;

          &::after,
          &::before {
            width: 8px;
            height: 1px;
          }
        `}}}
  ${({variant:e})=>{switch(e){case"success":return r`
          &::after,
          &::before {
            background-color: ${e=>e.theme.colors.darkGrey};
          }
        `;case"error":return r`
          &::after,
          &::before {
            background-color: ${e=>e.theme.colors.black};
          }
        `;default:return r`
          &::after,
          &::before {
            background-color: ${e=>e.theme.colors.lightBlue};
          }
        `}}}
`;o.defaultProps=t;export{o as Button};
